import React from "react";

//components
import { NavigationComponent } from "@components/layouts";

//menu
import navigation from "@utils/navigation";

//components
import { ScrumContainer } from '@components/scrum';

function ScrumPage() {
    const mainMenu = navigation && navigation.mainAdmin;
    return (
        <React.Fragment>
            <NavigationComponent data={mainMenu} />
            <div className="wrapper -scrumPage">
                <ScrumContainer />
            </div>
        </React.Fragment>
    );
}

export default ScrumPage;
